export default async function getCroppedImg(imageSrc, pixelCrop, resizeWidth = 500, resizeHeight = 500) {
  const createImage = (url) =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = () => resolve(image);
      image.onerror = (error) => reject(error);
      image.src = url;
    });

  const image = await createImage(imageSrc);

  // Canvas chứa crop theo pixelCrop
  const canvas = document.createElement("canvas");
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  const ctx = canvas.getContext("2d");

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  // Canvas mới để resize ảnh crop
  const resizedCanvas = document.createElement("canvas");
  resizedCanvas.width = resizeWidth;
  resizedCanvas.height = resizeHeight;
  const resizedCtx = resizedCanvas.getContext("2d");

  // Vẽ ảnh crop đã tạo lên canvas mới để resize
  resizedCtx.drawImage(canvas, 0, 0, resizeWidth, resizeHeight);

  return new Promise((resolve) => {
    resizedCanvas.toBlob((blob) => {
      if (!blob) {
        console.error("Canvas is empty");
        return;
      }
      blob.name = "cropped-resized.jpeg";
      resolve(blob);
    }, "image/jpeg");
  });
}
